import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiChopin, API_CHOPIN } from '../config/index';
import { Observable, of } from 'rxjs';
import { AppConfig } from '@shared/interfaces';
import INITIAL_CONFIG from '../config/config.json';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  constructor(
    @Inject(API_CHOPIN) private api: ApiChopin,
    private http: HttpClient
  ) {}

  getConfig(): Observable<AppConfig> {
    return this.http.get<AppConfig>(this.api.CONFIG());
    // return of(INITIAL_CONFIG);
  }

}
